module.exports = __webpack_public_path__ + "img/photo3.e72d0f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo3.jpg
// module id = meOq
// module chunks = 1